module.exports = __webpack_public_path__ + "img/ic_plus_square.052c3dd9.svg";